import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { countryIs, field, personalInfo, REQUIRED } from "./utils";
import { getDescription } from "../../utils";
import * as URUGUAY from "../../onboarding/profile-info/form/uy/constants.uy";

export const uruguayFields = {
  uyCid: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "uyCid",
    label: "Identification Number (Cédula de Identidad)",
    validations: REQUIRED,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uyCid", ""),
  }),
  uySeguroDeSaludBps: field({
    type: FieldTypes.select,
    informationType: "benefits",
    name: "uySeguroDeSaludBps",
    label: "Seguro de Salud BPS",
    validations: REQUIRED,
    placeholder: "Select Seguro de Salud BPS",
    options: URUGUAY.uySeguroDeSaludBpsOptions,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uySeguroDeSaludBps", ""),
    format: (value) =>
      getDescription(URUGUAY.uySeguroDeSaludBpsOptions, value) ?? value,
  }),
  uyPreviousEmploymentStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "uyPreviousEmploymentStatus",
    label: "Previous employment status (immediately preceding Justworks)",
    validations: REQUIRED,
    placeholder: "Select previous employment status",
    options: URUGUAY.uyPreviousEmploymentStatusOptions,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uyPreviousEmploymentStatus", ""),
    format: (value) =>
      getDescription(URUGUAY.uyPreviousEmploymentStatusOptions, value) ?? value,
  }),
  uyEducationLevel: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "uyEducationLevel",
    label: "Education level (highest academic level achieved)",
    validations: REQUIRED,
    placeholder: "Select education level",
    options: URUGUAY.uyEducationLevelOptions,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uyEducationLevel", ""),
    format: (value) =>
      getDescription(URUGUAY.uyEducationLevelOptions, value) ?? value,
  }),
  uyFieldOfEducation: field({
    type: FieldTypes.text,
    informationType: "identification",
    name: "uyFieldOfEducation",
    label: "Field of education/training",
    message:
      "Please list your studies or qualifications relevant to your position. If you attended university, include your degree or field of study (e.g., Systems Engineering, Student at the Faculty of Economics, Electronics Technician etc).",
    validations: REQUIRED,
    profileSection: "personalInfo",
    scenarios: {
      onboarding: countryIs("UY"),
    },
    value: personalInfo("uyFieldOfEducation", ""),
  }),
};
